import React from 'react';
import WhyPopover from './why_popover';

/*
 * Final payable table, rendered in the backend's order from final_payable_view. Values are to the
 * paisa; the informational carry forward is shown but not part of the arithmetic.
 */
const FinalPayable = ({ lines, gst_registered, csv_action = null }) => {
  if (!lines || !lines.length) {
    return <div className="tp-empty">No final payable computed for this month.</div>;
  }
  return (
    <div className="tp-card" style={{ maxWidth: 560 }}>
      <div className="tp-card-hd">
        <span className="tp-card-hd-title">Final payable</span>
        <span className="tp-card-hd-sub">
          Unrounded values; GST {gst_registered ? 'registered' : 'not applicable'}
        </span>
        {csv_action}
      </div>
      <table className="tp-fpt">
        <tbody>
          {lines.map((l) => (
            <tr
              key={l.key}
              className={`${l.is_total ? 'tp-fpt-total' : ''} ${
                l.is_informational ? 'tp-fpt-info' : ''
              }`}
            >
              <td>
                <span className="tp-fpt-sign">{l.sign_text}</span> {l.label}
                {l.is_informational ? (
                  <span className="tp-fpt-info-tag"> (informational)</span>
                ) : null}
              </td>
              <td>
                <WhyPopover
                  detail={l.explain}
                  amount_node={<span className={l.tone}>{l.amount_text}</span>}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FinalPayable;
